export const SellStepperName = {
    orderStep: "Order setup",
    ist: "Sell investments",
    review: "Review",
    confirmation: "Confirmation",
};

export const sellAllTooltip =
    "If the Adviser places a cash value sell with an amount that is equal to or greater than 95% of the current value of the fund we will alter this sell so that it alters to that proportion of units instead (excluding from the Investment Hub).";

export const treasureAssetTooltip = "If all investments are selected, then no investments will be protected.";

export const fundAllocationTooltip = "Please ensure there is sufficient Product cash to cover any Initial & Future charges that may be incurred by this trade.";
